import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser } from "../../lib/api";

export default function Profile() {
  const [user, setUser] = useState(readUser());
  useEffect(() => { api.get("/auth/me").then((r) => setUser(r.data)); }, []);
  return (
    <MemberLayout user={user} active="Profile">
      <div className="panel">
        <div className="panel-heading"><div><span className="eyebrow">YOUR ACCOUNT</span><h3>Profile details</h3></div></div>
        <div className="profile-grid">
          <div><span>Full name</span><strong data-testid="profile-name">{user?.full_name}</strong></div>
          <div><span>Username</span><strong>@{user?.username}</strong></div>
          <div><span>Email</span><strong>{user?.email}</strong></div>
          <div><span>Phone</span><strong>{user?.phone || "—"}</strong></div>
          <div><span>Member since</span><strong>{user?.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}</strong></div>
          <div><span>Role</span><strong>{user?.role}</strong></div>
          <div><span>Referral code</span><strong>{user?.referral_code}</strong></div>
          <div><span>Deposit reference</span><strong data-testid="profile-reference">{user?.deposit_reference}</strong></div>
        </div>
      </div>
    </MemberLayout>
  );
}
